/**
 * The hook end-to-end tests reach the row buffer through.
 *
 * Upstream's grid spec forces the buffer to hold one specific slice, then acts
 * on a row outside it -- which is the only way to exercise what happens when a
 * realtime event or an edit names a row the client is not holding. There is no
 * way to arrange that through the interface: scrolling fetches, so any scroll
 * that reaches the row also loads it.
 *
 * Gated on a feature flag rather than on `import.meta.env.MODE`, because the
 * end-to-end stack runs a *production* build -- the same artifact that ships --
 * and a mode check would be false there. `FEATURE_FLAGS` is unset in every
 * shipped image, so this is absent unless a deployment asks for it by name.
 */
import { isFeatureEnabled } from '@/shared/config/runtime'
import { rowWindowsForTable, rowWindowsForView } from './rowWindowRegistry'

export const TEST_SEAM_FLAG = 'e2e_row_window'

export interface LithosTestSeam {
  rowWindowsForTable: typeof rowWindowsForTable
  rowWindowsForView: typeof rowWindowsForView
}

declare global {
  interface Window {
    __lithosTest?: LithosTestSeam
  }
}

/** Installs the seam if this deployment asked for it. A no-op otherwise. */
export function installTestSeam(): void {
  if (!isFeatureEnabled(TEST_SEAM_FLAG)) return
  window.__lithosTest = { rowWindowsForTable, rowWindowsForView }
}
